// UPDATE THE CLIENT RECORD TO INCLUDE MONTH OF CREATION

import dayjs from 'dayjs';

export function UpdateClientRecordsAsync(){
    // will grab a client and add the createdMonth field
    // loop through each id (1-8899)
}